import {Component, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {AuthService} from '@services/http/auth.service';
import {UserService} from '@services/http/user.service';
import {ScreenService} from '@services/screen.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {CachedDataService} from '@services/data/cached-data.service';
import {Router} from '@angular/router';
import {BsModalComponent} from "ng2-bs3-modal";
import {ConfirmDeletingModalComponent} from "../../modal";
import {User} from "@models/user";

@Component({
  selector: 'delete-account',
  templateUrl: './deleteUser.component.html'
})

export class DeleteUserComponent implements OnInit {
  @ViewChild('confirmDeletingModal') confirmDeletingModal: ConfirmDeletingModalComponent;

  private currentUser: User
  public isError: boolean;

  constructor(
    private screenService: ScreenService,
    private usersService: UserService,
    private cachedDataService: CachedDataService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.isError = false;
    this.currentUser = this.cachedDataService.getCurrentUser();
    this.screenService.isShowLoader = false;
    this.confirmDeletingModal.dialog.onClose.subscribe(result => {
      if (result) {
        this.screenService.isShowLoader = true;
        this.usersService.delete(this.currentUser.id).subscribe(result => {
          this.screenService.isShowLoader = false;
          this.cachedDataService.clearCache();
          this.router.navigate(['/signin']);
        }, error => {
          this.screenService.isShowLoader = false;
          this.isError = true;
        });
      }
    });
  }

  cancel() {
    this.router.navigate(['/personal', this.currentUser.id]);
  }

  delete() {
    this.confirmDeletingModal.dialog.open();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/auth/deleteUser/deleteUser.component.ts